import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  light?: boolean;
  className?: string;
}
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  light = false,
  className = ''
}: SectionHeadingProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.6
  }} className={`text-center mb-12 lg:mb-16 ${className}`} data-id="element-1893">
      {eyebrow && <div className="inline-block mb-4" data-id="element-1894">
          <span className={`font-heading font-bold text-xs md:text-sm tracking-[0.15em] uppercase ${light ? 'text-brand-gold' : 'text-brand-purple'}`} data-id="element-1895">
            {eyebrow}
          </span>
        </div>}
      <h2 className={`font-heading font-bold text-3xl md:text-4xl lg:text-5xl mb-5 text-balance ${light ? 'text-white' : 'text-brand-text'}`} data-id="element-1896">
        {title}
      </h2>
      <div className="h-[2px] w-16 bg-brand-gold mx-auto rounded-full" data-id="element-1897" />
      {subtitle && <p className={`mt-5 font-subtitle text-lg md:text-xl max-w-2xl mx-auto leading-relaxed ${light ? 'text-white/85' : 'text-brand-textSec'}`} data-id="element-1898">
          {subtitle}
        </p>}
    </motion.div>;
}